
import { Drawer } from "element-ui"
import OfflinePaymentCountDown from "./offlinePaymentCountDown.vue"
import countDown from "@/components/order/countDown.vue"
import { createQrPolling } from "@/utils/qrCodePolling"
import { generateQR, tooltipCustomStyle } from "@/utils/utils"
import { getOrderDetails } from "@/api/order.js"
export default {
  name: "OfflinePaymentPopup",
  components: {
    [Drawer.name]: Drawer,
    countDown,
    OfflinePaymentCountDown
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sourceData: {
      type: Object,
      default: () => {}
    },
    orderNo: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showQRTitle: this.$t("order.offlinePaymentQrCode"),
      curVisible: false,
      qrCodeStr: "", // 二维码字符串
      showQRcodeSrc: "", // 二维码图片
      qrPolling: null,
      orderDetails: {}, // 订单全项
      frontOrderVO: {}, // 订单详情
      smallTicketInfo: null, // Items Subtotal
      formatTime: {
        hour: "h ",
        minute: "m ",
        second: "s"
      }
    }
  },
  watch: {
    visible(val) {
      this.curVisible = val
      if (val) {
        if (!this.qrPolling) {
          this.initPageQrPolling()
        } else {
          this.qrPolling?.start()
        }
      } else {
        this.qrPolling?.stop()
      }
    },
    sourceData: {
      handler(newVal) {
        const { smallTicketInfo, frontOrderVO } = newVal || {}
        this.orderDetails = newVal
        this.frontOrderVO = frontOrderVO || {}
        this.smallTicketInfo = smallTicketInfo
      },
      deep: true,
      immediate: true
    },
    qrCodeStr: {
      handler(val) {
        if (val) {
          this.initQrCode(val)
        }
      }
    }
  },
  beforeDestroy() {
    this.qrPolling?.stop()
  },
  methods: {
    tooltipCustomStyle(index) {
      return tooltipCustomStyle(index)
    },
    handleClose() {
      this.qrPolling?.stop()
      this.$emit("close")
    },
    curCount(count) {
      if (count <= 0) {
        this.handleClose()
        this.$bus.$emit("onRefreshOrderList")
      }
    },
    async initQrCode(codeStr) {
      try {
        if (codeStr) {
          this.showQRcodeSrc = await generateQR(codeStr)
        }
      } catch (err) {
        console.error("轮询/生成二维码失败：", err)
      }
    },
    requestOfflineOrderData(isLoading = false) {
      return getOrderDetails(
        {
          param: { orderId: this.orderNo }
        },
        isLoading
      ).then(res => {
        return res.data || {}
      })
    },
    initPageQrPolling() {
      this.qrPolling = createQrPolling({
        getQrField(res) {
          return res.qrCode
        },
        request: () => {
          return this.requestOfflineOrderData(false)
        },
        callback: res => {
          const { frontOrderVO } = res || {}
          this.qrCodeStr = frontOrderVO.offlinePaymentOrderInfo || ""
        },
        isSuccess: res => {
          return res?.frontOrderVO?.orderStatus === 9 // 9:支付成功
        },
        onSuccess: res => {
          this.handleClose()
          this.$bus.$emit("onRefreshOrderList")
        },
        onError(err) {
          console.log("onError", err)
        }
      })
      this.qrPolling?.start()
    },
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    getToolTipContent(list) {
      const { childTicketList = [], remarkList = [] } = list
      if (childTicketList && childTicketList.length) {
        const result = childTicketList.map(
          (item, index) => `<div style="display: flex;justify-content: space-between;margin-top: ${
            index === 0 ? "0" : "0.16rem"
          };">
              <span>${item.smallTicketLineName}</span>
              <span>${item.smallTicketLinePriceWithSymbol}</span></div>`
        )

        return result
      }

      return remarkList || []
    }
  }
}
